export const mapStyles = [
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.country",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffeb3b"
      },
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.country",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#808080"
      },
      {
        visibility: "on"
      },
      {
        weight: 1
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "landscape",
    stylers: [
      {
        lightness: 40
      }
    ]
  },
  {
    featureType: "poi",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.highway",
    stylers: [
      {
        saturation: -100
      },
      {
        lightness: 60
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ccdcff"
      }
    ]
  }
]

export const mapStylesWithLabels = [
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
  { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: "#808080"}, { visibility: "on" }, { weight: 1}] },
  { featureType: 'administrative.land_parcel', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'landscape', stylers: [{ lightness: 0 }] },
  { featureType: 'poi', elementType: 'labels.icon', stylers: [{ lightness: 0 }, { weight: 1 }] },
  { featureType: 'poi', elementType: 'labels.text', stylers: [{ lightness: 0 }] },
  { featureType: 'poi.attraction', elementType: 'labels.icon', stylers: [{ lightness: 0, visibility: 'off' }] },
  { featureType: 'poi.business', elementType: 'labels.icon', stylers: [{ lightness: 0 }] },
  { featureType: 'poi.government', elementType: 'labels.icon', stylers: [{ lightness: 0, visibility: 'off' }] },
  { featureType: 'poi.medical', elementType: 'labels.icon', stylers: [{ lightness: 0 }] },
  { featureType: 'poi.park', elementType: 'labels.icon', stylers: [{ lightness: 0, visibility: 'off' }] },
  { featureType: 'poi.park', elementType: 'labels.text', stylers: [{ lightness: 0, visibility: 'off' }] },
  { featureType: 'poi.place_of_worship', elementType: 'labels.icon', stylers: [{ lightness: 0, visibility: 'off' }] },
  { featureType: 'poi.school', elementType: 'labels.icon', stylers: [{ lightness: 0 }] },
  { featureType: 'poi.sports_complex', elementType: 'labels.icon', stylers: [{ lightness: 0, visibility: 'off' }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ lightness: 0 }] },
  { featureType: 'transit', elementType: 'labels.icon', stylers: [{ lightness: 0 }] },
  { featureType: 'transit', elementType: 'labels.text', stylers: [{ lightness: 0 }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'road.highway', stylers: [{ saturation: -100 }, { lightness: 0 }] },
  { featureType: 'road.local', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#ccdcff' }] },
];
